import { useMediaQuery } from '@repo/hooks/useMediaQuery';

/**
 * Wide tables switch to a compact column set (related fields merged, no pinned
 * columns) where it fits without sideways scrolling: laptop/desktop widths and
 * phone cards. In-between widths (e.g. tablet landscape) keep every column and
 * scroll sideways.
 */
export const COMPACT_TABLE_MEDIA_QUERY = '(min-width: 1280px)';
export const PHONE_TABLE_MEDIA_QUERY = '(max-width: 767px)';

/** True where a table should use its compact columns. */
export const useCompactTableLayout = (wideQuery: string = COMPACT_TABLE_MEDIA_QUERY) => {
  const isPhone = useMediaQuery(PHONE_TABLE_MEDIA_QUERY);
  const isWide = useMediaQuery(wideQuery);
  return isPhone || isWide;
};
